document.addEventListener('submit',function(e){const form=e.target;if(!form.matches('form[action*="/cart/add"]'))return;});
/* card image slider: arrows + dots */
(function(){
  function slider(btn){return btn.parentNode.querySelector('.card-slider')}
  function idx(s){return Math.round(s.scrollLeft/s.clientWidth)}
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.card-arrow');if(!b)return;
    e.preventDefault();e.stopPropagation();
    var s=slider(b);if(!s)return;var n=s.children.length;
    var i=idx(s)+(b.classList.contains('card-next')?1:-1);
    if(i<0)i=n-1;if(i>=n)i=0;
    s.scrollTo({left:i*s.clientWidth,behavior:'smooth'});
  });
  document.addEventListener('scroll',function(e){
    var s=e.target;if(!s||!s.classList||!s.classList.contains('card-slider'))return;
    var dots=s.parentNode.querySelectorAll('.card-dots i');var i=idx(s);
    for(var k=0;k<dots.length;k++){dots[k].className=(k===i)?'on':''}
  },true);
})();
